"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureAwardType = void 0;
var FeatureAwardType = exports.FeatureAwardType = /*#__PURE__*/function (FeatureAwardType) {
  FeatureAwardType[FeatureAwardType["Coins"] = 0] = "Coins";
  FeatureAwardType[FeatureAwardType["FreeSpins"] = 1] = "FreeSpins";
  FeatureAwardType[FeatureAwardType["Respin"] = 2] = "Respin";
  FeatureAwardType[FeatureAwardType["CoinsMultiplier"] = 3] = "CoinsMultiplier";
  FeatureAwardType[FeatureAwardType["ExpandingSymbolSelect"] = 4] = "ExpandingSymbolSelect";
  FeatureAwardType[FeatureAwardType["ExpandingSymbol"] = 5] = "ExpandingSymbol";
  FeatureAwardType[FeatureAwardType["Collect"] = 6] = "Collect";
  FeatureAwardType[FeatureAwardType["CollectReward"] = 7] = "CollectReward";
  FeatureAwardType[FeatureAwardType["SpinExpandingSymbolSelect"] = 8] = "SpinExpandingSymbolSelect";
  FeatureAwardType[FeatureAwardType["Lock"] = 9] = "Lock";
  FeatureAwardType[FeatureAwardType["AdditionalFreespins"] = 10] = "AdditionalFreespins";
  FeatureAwardType[FeatureAwardType["WinMultiplier"] = 11] = "WinMultiplier";
  FeatureAwardType[FeatureAwardType["TurnWildSymbol"] = 12] = "TurnWildSymbol";
  FeatureAwardType[FeatureAwardType["GridWin"] = 13] = "GridWin";
  return FeatureAwardType;
}({});
//# sourceMappingURL=FeatureAwardType.js.map